export default {
  title: 'Detalii cod promoțional',
  back: 'Înapoi la coduri promoționale',
  tabs: {
    customers: 'Clienți',
    orders: 'Comenzi',
  },
  metrics: {
    gmv: 'GMV',
    average_order_value: 'Val. medie comandă',
    customer_adoption: 'Clienți unici',
  },
  toasts: {
    failed_to_load_stats: 'Eroare la încărcarea statisticilor',
  },
};
